import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const WrapperModal = styled.div`
  width: 100%;
  max-width: 560px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15), 0 6px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const Header = styled.div`
  position: relative;
  .top-bar {
    height: 64px;
    background: #f8f8f8;
    border-bottom: 1px solid #e6e6e6;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  line-height: 1;
  font-size: 22px;
  color: #737373;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
  &:focus-visible {
    outline: 2px solid #2b7cff;
    outline-offset: 2px;
  }
`;

export const Content = styled.div`
  padding: 24px 28px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 44px;
  height: 44px;
  margin-bottom: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Title = styled.h2`
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  color: #373737;
  margin: 0 0 12px;
  text-align: center;
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #5a5a5a;
  margin: 0 0 24px;
  text-align: center;
  max-width: 460px;
`;

export const Actions = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ActionButton = styled.button`
  width: 100%;
  max-width: 420px;
  border: none;
  border-radius: 28px;
  padding: 14px 18px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  background: #f2c86e;
  color: #2f2f2f;

  &:hover {
    filter: brightness(0.97);
  }
  &:active {
    filter: brightness(0.94);
  }
`;
